export enum SearchType {
    TRACK = "Track",
    PLAYLIST = "Playlist",
    ARTIST = "Artist",
}
